import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Card from 'antd/es/card/Card'
import { Formik } from 'formik'

import { PagedList, SearchSmsFilter, SearchSmsItemResponse, searchSmsMessages } from 'core'

import SmsTable from 'common/components/smsTable/smsTable'

import { Col, DefaultInputV2, DefaultSelectV2, Icon, Row } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import './style.less'

const SmsMessages = () => {
  const { t: translate } = useTranslation()

  const [filter, setFilter] = useState<SearchSmsFilter>({
    pageNumber: 1,
    pageSize: 25,
    orderColumn: 'sendDate',
    orderDescending: false,
    q: '',
    lastXDays: 30,
  })

  const {
    data: messages,
    isLoading: messagesLoading,
    sendQuery,
  } = useQueryRequestV2<PagedList<SearchSmsItemResponse>>()

  useEffect(() => {
    ;(async () => await sendQuery(() => searchSmsMessages(filter)))()
  }, [filter])

  return (
    <Card
      className="sms-card pt-16"
      title={
        <div>
          <Formik
            enableReinitialize={true}
            initialValues={filter}
            onSubmit={(values) => {
              setFilter({
                ...filter,
                pageNumber: 1,
                q: values.q,
                lastXDays: values.lastXDays,
              })
            }}
          >
            {(formik) => (
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col xs={24} sm={8}>
                    <span className="title">
                      {translate('admin-dashboard.left-navigation.messages.sms-messages.header')}
                    </span>
                  </Col>
                  <Col xs={24} sm={12}>
                    <DefaultInputV2
                      suffix={<Icon type="fal fa-search" fontAwesome />}
                      onKeyUp={async (e: any) => {
                        if (e.keyCode == 13) {
                          await formik.submitForm()
                        }
                      }}
                      className="mr-8"
                      placeholder={translate('csi-dashboard.email-search.input-placeholder')}
                      name={'q'}
                    />
                  </Col>
                  <Col xs={24} sm={4} className="sms-filter">
                    <DefaultSelectV2
                      className="last-x-days full-width"
                      name="lastXDays"
                      items={[
                        { id: 30, name: 'Last 30 days' },
                        { id: 60, name: 'Last 60 days' },
                        { id: 90, name: 'Last 90 days' },
                      ]}
                      onChange={(lastXDays) => {
                        setFilter({
                          ...filter,
                          pageNumber: 1,
                          lastXDays: lastXDays,
                        })
                      }}
                    />
                  </Col>
                </Row>
              </form>
            )}
          </Formik>
        </div>
      }
    >
      <Row>
        <Col xs={24}>
          <SmsTable
            messages={messages}
            loadingSms={messagesLoading}
            onChange={(filter2) => {
              setFilter({
                ...filter,
                orderDescending: filter2.orderDescending,
                pageSize: filter2.pageSize,
                orderColumn: filter2.orderColumn,
                pageNumber: filter2.pageNumber,
                lastXDays: filter.lastXDays,
                q: filter.q,
              })
            }}
          ></SmsTable>
        </Col>
      </Row>
    </Card>
  )
}

export default SmsMessages
